<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex max-w-[600px] justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="header-text">Enter VINs in your ELD Account</h3>
        <p class="mb-8 text-left text-body-color">
          Click on the button below after you've entered VINs on each applicable
          vehicle in your connected ELD account.
        </p>

        <div
          class="flex w-full flex-col md:flex-row md:flex-row-reverse md:gap-x-2"
        >
          <button-main @click="$emit('submit')">I Updated My ELD</button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Not Now
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import WordTools from '@/mixins/wordTools';

export default {
  name: 'EnterVinsOnELDModal',
  components: {
    Modal,
    ButtonMain,
  },
  mixins: [WordTools],
  props: {
    visible: Boolean,
    type: String,
  },
  emits: ['close'],
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-4 text-dark-blue;
}
</style>
